import { defineProperty as _defineProperty, toConsumableArray as _toConsumableArray, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { addBreakpointMedia, objectDeepMerging, ThemeBreakpoints } from '../../utils/index.js';
import { createStyles } from '@mantine/core';
import { useEmptyAppStyle } from './Empty.app.style.js';
import { RootVariable } from './constant.js';

var resetVariable = Object.values(RootVariable).reduce(function (ac, cr) {
  ac[cr] = 'none';
  return ac;
}, {});
var defaultVariable = _defineProperty(_defineProperty({}, RootVariable.EMPTY_LABEL_COLOR, 'var(--gui-color-text-3)'), RootVariable.EMPTY_LABEL_LINE_HEIGHT, 1.5);
var getDefaultStyles = function getDefaultStyles() {
  return {
    root: _objectSpread2(_objectSpread2({}, resetVariable), defaultVariable)
  };
};
var getLgStyles = function getLgStyles() {
  return {
    root: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, RootVariable.EMPTY_IMAGE_SIZE, '160px'), RootVariable.EMPTY_IMAGE_GAP, '24px'), RootVariable.EMPTY_LABEL_GAP, '80px'), RootVariable.EMPTY_LABEL_FONT_SIZE, '24px'), RootVariable.EMPTY_LABEL_FONT_WEIGHT, 500)
  };
};
var getMdStyles = function getMdStyles() {
  return {
    root: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, RootVariable.EMPTY_IMAGE_SIZE, '120px'), RootVariable.EMPTY_IMAGE_GAP, '16px'), RootVariable.EMPTY_LABEL_GAP, '48px'), RootVariable.EMPTY_LABEL_FONT_SIZE, '16px'), RootVariable.EMPTY_LABEL_FONT_WEIGHT, 500)
  };
};
var getSmStyles = function getSmStyles() {
  return {
    root: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, RootVariable.EMPTY_IMAGE_SIZE, '96px'), RootVariable.EMPTY_IMAGE_GAP, '16px'), RootVariable.EMPTY_LABEL_GAP, '24px'), RootVariable.EMPTY_LABEL_FONT_SIZE, '14px'), RootVariable.EMPTY_LABEL_FONT_WEIGHT, 400)
  };
};
var getXsStyles = function getXsStyles() {
  return {
    root: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, RootVariable.EMPTY_IMAGE_SIZE, '64px'), RootVariable.EMPTY_IMAGE_GAP, '8px'), RootVariable.EMPTY_LABEL_GAP, '24px'), RootVariable.EMPTY_LABEL_FONT_SIZE, '12px'), RootVariable.EMPTY_LABEL_FONT_WEIGHT, 400)
  };
};
var getCurrentVariantAndSizeStyle = function getCurrentVariantAndSizeStyle(_ref) {
  var size = _ref.size;
  return objectDeepMerging(getDefaultStyles(), _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, size === 'lg' ? getLgStyles() : {}), size === 'md' ? getMdStyles() : {}), size === 'sm' ? getSmStyles() : {}), size === 'xs' ? getXsStyles() : {}));
};
var useEmptyStyle = createStyles(function (_, params) {
  var size = params.size,
    hasButton = params.hasButton,
    breakpoints = params.breakpoints,
    isH5MappingAppStyle = params.isH5MappingAppStyle;
  var appStyle = useEmptyAppStyle();
  return addBreakpointMedia(function () {
    return objectDeepMerging(getCurrentVariantAndSizeStyle({
      size: size
    }), {
      root: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      },
      img: {
        width: "var(".concat(RootVariable.EMPTY_IMAGE_SIZE, ")"),
        height: "var(".concat(RootVariable.EMPTY_IMAGE_SIZE, ")"),
        marginBottom: "var(".concat(RootVariable.EMPTY_IMAGE_GAP, ")")
      },
      label: {
        lineHeight: "var(".concat(RootVariable.EMPTY_LABEL_LINE_HEIGHT, ")"),
        color: "var(".concat(RootVariable.EMPTY_LABEL_COLOR, ")"),
        textAlign: 'center',
        fontFamily: 'inherit',
        fontSize: "var(".concat(RootVariable.EMPTY_LABEL_FONT_SIZE, ")"),
        fontWeight: "var(".concat(RootVariable.EMPTY_LABEL_FONT_WEIGHT, ")"),
        marginBottom: hasButton ? "var(".concat(RootVariable.EMPTY_LABEL_GAP, ")") : 0,
        '& > a': {
          color: 'var(--gui-color-text-5)',
          cursor: 'pointer',
          textDecoration: 'none'
        }
      }
    });
  }, {}, [].concat(_toConsumableArray(isH5MappingAppStyle ? [{
    maxWidth: 'md',
    styles: appStyle
  }] : []), _toConsumableArray(breakpoints)), ThemeBreakpoints);
});

export { useEmptyStyle as default };
//# sourceMappingURL=Empty.style.js.map
